import { useTranslation } from "react-i18next";

export default function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (language: "en" | "pt") => {
    i18n.changeLanguage(language);
    localStorage.setItem("language", language);
  };

  const currentLanguage = i18n.language;

  return (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage("en")}
        className={currentLanguage === "en" ? "active" : ""}
      >
        EN
      </button>

      <span>|</span>

      <button
        onClick={() => changeLanguage("pt")}
        className={currentLanguage === "pt" ? "active" : ""}
      >
        PT
      </button>
    </div>
  );
}